module.exports = __webpack_public_path__ + "static/salon-pasajeros---asientos-7e5e2153a24fddd43ab3a06b2b299a0d.jpg";